import { useMutation } from 'react-query'
import { useLocation } from 'react-router'
import { toast } from 'react-toastify'
import { postTransactions } from 'services/easyPay'

export default function useSetTransactions() {
    const { state } = useLocation()
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: ITransactionPayload) => {
            return postTransactions(payload)
        },
        onSuccess: (result, variables) => {
            localStorage.setItem(
                'toBePaidTransactions',
                JSON.stringify({
                    type: 'group-all-payment',
                    data: state.toBePaidTransactions,
                    //@ts-ignore
                    pk: result?.pk,
                    //@ts-ignore
                    gateway: result?.gateway,
                })
            )
            //@ts-ignore
            window.location.replace(result?.pay_url)
        },
        onError: () => {
            toast.error('مشکلی پیش آمده!')
        },
    })
    return { mutate, isLoading }
}
